/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ZoomControlComponent } from './zoom-control.component';

// This module is to expose a fake tabview tabs of the member aspect for use in projects page
// that is still in AnugularJS before it can be updated to Angular
@NgModule({
	imports: [BrowserModule],
	declarations: [ZoomControlComponent],
	exports: [BrowserModule, ZoomControlComponent],
})
export class ZoomControlModule {}
